import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import "@radix-ui/themes/styles.css";
import { router } from "branchAndBrandSpecific/Routes";
import useDocumentTitle from "./hooks/useDocumentTitle";
import { Theme } from "@radix-ui/themes";
import Plausible from "plausible-tracker";
import { themeMap, themeRadiusMap } from "./utils/constants/Themes";
import firebase from "firebase/compat/app";
import { useAuthPersistState } from "./store/auth/auth.store";
import { useCurrentUserProfile } from "./store/auth/userProfile.store";
import { useAtomValue } from "jotai";
import { clientAtom } from "./utils/atoms/atomClient";
import { brand } from "./constants/brandVariables/brandVariables";

function App(): JSX.Element {
  const user = useAuthPersistState((state) => state.user);
  const profile = useCurrentUserProfile((s) => s.user);
  const setProfile = useCurrentUserProfile((s) => s.setUser);
  const appTestingEnabled = false;

  const { trackEvent } = Plausible({
    trackLocalhost: false,
  });
  window.scrollTo({
    top: 0,
  });

  useEffect(() => {
    trackEvent("signup");
    window.scrollTo({
      top: 0,
    });
    let link: any = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      if (link) {
        link.rel = "icon";
        document.head.appendChild(link);
        link.href = brand.logos.favicon;
      }
    }
  }, []);

  // Check and add claims on login or auth change
  const handleAddClaims = async () => {
    if (!profile) {
      return;
    }

    const userFirebaseAuth = firebase.auth().currentUser;
    if (!userFirebaseAuth) {
      return;
    }

    const idTokenResult = await userFirebaseAuth.getIdTokenResult(false);

    // Add roles
    const authRoleClaim = idTokenResult?.claims.authRole;
    const missingAuthRole = authRoleClaim && !profile?.claims?.authRole;
    if (missingAuthRole) {
      setProfile({
        ...profile,
        claims: {
          authRole: authRoleClaim || null,
        },
      });
    }
  };

  useEffect(() => {
    handleAddClaims();
  }, [profile, user]);

  useDocumentTitle("");

  // localy and quickly test functions &  see responses
  // if (window.location.hostname.includes("localhost") && appTestingEnabled) {
  //   AppTesting();
  // }

  return (
    <Theme {...brand.theme}>
      <RouterProvider router={router} />
    </Theme>
  );
}

export default App;
